import {
    CalendarOutlined,
    ExclamationCircleOutlined,
    FilterOutlined,
} from '@ant-design/icons';
import type { DegradationCause } from '~stores/kpi-envelope';

/**
 * The single source both the card body and the chart's under-legend note
 * read, so the two cannot drift. `source_unavailable`'s label omits the
 * store's name: it also covers a request that died inside the CMS.
 */
const PRESENTATION: Record<
    DegradationCause,
    { label: string; Icon: typeof CalendarOutlined }
> = {
    period_not_covered: {
        label: 'No data for this period',
        Icon: CalendarOutlined,
    },
    source_unavailable: {
        label: 'Unavailable',
        Icon: ExclamationCircleOutlined,
    },
    region_unsupported: { label: 'Region not servable', Icon: FilterOutlined },
};

export const DegradationNote = ({
    cause,
    reason,
}: {
    cause?: DegradationCause;
    reason: string;
}) => {
    const presentation = cause ? PRESENTATION[cause] : undefined;

    if (!presentation) {
        return (
            <span
                className="footnote_description"
                style={{ color: 'var(--Text-Secondary)' }}
            >
                {reason}
            </span>
        );
    }

    return (
        <span
            className="footnote_description"
            style={{
                color: 'var(--Text-Secondary)',
                display: 'inline-flex',
                gap: 6,
                alignItems: 'baseline',
            }}
        >
            <presentation.Icon aria-hidden />
            <strong>{presentation.label}</strong>
            <span>{reason}</span>
        </span>
    );
};
